// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8be8e662","453":"c6e69c7f","732":"2fb47d5c","977":"670eb82b"}[chunkId] + ".chunk.js";
};